package net.gorillagroove.sync.strategies

import net.gorillagroove.util.Instant
import kotlinx.serialization.Serializable
import net.gorillagroove.db.Database
import net.gorillagroove.api.UserId
import net.gorillagroove.db.DbSyncStatus
import net.gorillagroove.db.DbUser
import net.gorillagroove.sync.*
import net.gorillagroove.user.RawUserVisibilityType
import net.gorillagroove.user.UserService
import net.gorillagroove.user.toUser

object UserSyncStrategy : SyncDownStrategy {
    override val syncType: SyncableEntity = SyncableEntity.USER

    override suspend fun syncDown(syncStatus: DbSyncStatus, onPageSyncedHandler: PageSyncHandler) {
        fetchSyncEntities<UserResponse>(syncType, syncStatus, onPageSyncedHandler) { changeSet ->
            handleSave(changeSet)
        }
    }

    fun handleSave(changeSet: EntityChangeContent<UserResponse>) {
        Database.db.transaction {
            changeSet.newAndModified.forEach {
                Database.userDao.upsert(it.asUser())
            }
            changeSet.removed.forEach {
                Database.userDao.delete(UserId(it))
            }
        }

        if (changeSet.newAndModified.isNotEmpty() || changeSet.removed.isNotEmpty()) {
            UserService.broadcastUserChange(changeSet.newAndModified.map { it.asUser().toUser() })
        }
    }
}

@Serializable
data class UserResponse(
    val id: UserId,
    val name: String,
    val lastActivity: Instant?,
    val yourVisibility: RawUserVisibilityType,
    val theirVisibility: RawUserVisibilityType,
    val createdAt: Instant,
) {
    fun asUser() = DbUser(
        id = id,
        name = name,
        lastActivity = lastActivity,
        createdAt = createdAt,
        yourVisibility = yourVisibility,
        theirVisibility = theirVisibility
    )
}
